import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';

import HiwStepsDesktop from './HiwStepsDesktop';
import HiwStepsMobile from './HiwStepsMobile';

const HiwSteps = () => {
  const { isBiggerThanPhablet } = useMediaQuery();
  return isBiggerThanPhablet() ? <HiwStepsDesktop /> : <HiwStepsMobile />;
};

export default HiwSteps;
